import React, { useState, useCallback, useMemo, memo } from "react";
import {
  Grid,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Button,
  CircularProgress,
  Box,
} from "@mui/material";
import ContentModal from "components/ContentModal";

function EditHPQuarterYearModal({
  handleClose,
  gridData,
  quarterOptions,
  yearOptions,
  onSubmit,
}) {
  const [quarter, setQuarter] = useState("");
  const [year, setYear] = useState("");
  const [loading, setLoading] = useState(false);

  const { filteredQuarters, filteredYears } = useMemo(() => {
    if (
      Array.isArray(quarterOptions) &&
      quarterOptions.length > 0 &&
      Array.isArray(yearOptions) &&
      yearOptions.length > 0
    ) {
      return { filteredQuarters: quarterOptions, filteredYears: yearOptions };
    }

    // Filter out policies with empty quarter or null/empty year
    const validPolicies = gridData.filter(
      (p) =>
        p.quarter && p.quarter.trim() !== "" && p.year != null && p.year !== ""
    );

    const uniqueQuarters = [
      ...new Set(validPolicies.map((p) => p.quarter)),
    ].sort();

    const uniqueYears = [...new Set(validPolicies.map((p) => p.year))].sort(
      (a, b) => a - b
    );

    return { filteredQuarters: uniqueQuarters, filteredYears: uniqueYears };
  }, [gridData, quarterOptions, yearOptions]);

  const handleSubmit = useCallback(async () => {
    setLoading(true);
    try {
      await onSubmit(quarter, year);
    } catch (error) {
      console.error("Submission failed:", error);
    } finally {
      setLoading(false);
    }
  }, [onSubmit, quarter, year]);

  return (
    <ContentModal
      maxWidth={"sm"}
      handleClose={handleClose}
      content={
        <Box display="flex" gap={2} sx={{ p: 1 }}>
          <FormControl sx={{ minWidth: 150, flex: 1 }}>
            <InputLabel id="quarter">Quarter</InputLabel>
            <Select
              id="quarter"
              label="Quarter"
              value={quarter}
              onChange={(e) => setQuarter(e.target.value)}
            >
              {filteredQuarters.map((q) => (
                <MenuItem key={q} value={q}>
                  {q}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <FormControl sx={{ minWidth: 150, flex: 1 }}>
            <InputLabel id="year">Year</InputLabel>
            <Select
              id="year"
              label="Year"
              value={year}
              onChange={(e) => setYear(e.target.value)}
            >
              {filteredYears.map((y) => (
                <MenuItem key={y} value={y}>
                  {y}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Box>
      }
      actions={
        <Button
          disabled={!year || !quarter || loading}
          onClick={handleSubmit}
          startIcon={loading && <CircularProgress size={20} />}
        >
          {loading ? "Submitting..." : "Submit"}
        </Button>
      }
      title="CAB Year and Quarter"
      open
    />
  );
}

export default EditHPQuarterYearModal;
